export default "__VITE_ASSET__542e5337__"